import { render, staticRenderFns } from "./MyForms.component.html?vue&type=template&id=cd5e3d48&scoped=true&"
import script from "./MyForms.component.ts?vue&type=script&lang=ts&"
export * from "./MyForms.component.ts?vue&type=script&lang=ts&"
import style0 from "./MyForms.component.scss?vue&type=style&index=0&id=cd5e3d48&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd5e3d48",
  null
  
)

export default component.exports